"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GridDetailPanel = GridDetailPanel;
var React = _interopRequireWildcard(require("react"));
var _styles = require("@mui/material/styles");
var _useResizeObserver = require("@mui/x-internals/useResizeObserver");
var _useGridRootProps = require("../hooks/utils/useGridRootProps");
var _useGridPrivateApiContext = require("../hooks/utils/useGridPrivateApiContext");
var _jsxRuntime = require("react/jsx-runtime");
var DetailPanel = (0, _styles.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'DetailPanel',
    overridesResolver: function(props, styles) {
        return styles.detailPanel;
    }
})(function(param) {
    var theme = param.theme;
    return {
        width: 'calc(var(--DataGrid-rowWidth) - var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))',
        backgroundColor: (theme.vars || theme).palette.background.default,
        overflow: 'auto'
    };
});
function GridDetailPanel(props) {
    var rowId = props.rowId, height = props.height, className = props.className, children = props.children;
    var apiRef = (0, _useGridPrivateApiContext.useGridPrivateApiContext)();
    var ref = React.useRef(null);
    var rootProps = (0, _useGridRootProps.useGridRootProps)();
    var ownerState = rootProps;
    var hasAutoHeight = height === 'auto';
    React.useLayoutEffect(function() {
        if (hasAutoHeight && typeof ResizeObserver === 'undefined') {
            // Fallback for IE
            apiRef.current.storeDetailPanelHeight(rowId, ref.current.clientHeight);
        }
    }, [
        apiRef,
        hasAutoHeight,
        rowId
    ]);
    (0, _useResizeObserver.useResizeObserver)(ref, function(entries) {
        var _entries = _sliced_to_array(entries, 1), entry = _entries[0];
        var observedHeight = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
        apiRef.current.storeDetailPanelHeight(rowId, observedHeight);
    }, hasAutoHeight);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DetailPanel, {
        ref: ref,
        ownerState: ownerState,
        role: "presentation",
        style: {
            height: height
        },
        className: className,
        children: children
    });
}
